export default __webpack_public_path__ + "static/media/logo.ccfabbf0.png";